import {
  Button,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export const VisulizadorActivo = ({
  planActivo,
  handlePriorityChange,
  setReorderedItems,
  reorderedItems,
  updatePrioridad,
  handleOpenNuevoItemSec,
  handleCheckboxChange,
  handleOpenEditSec,
}) => {
  return (
    <Grid container spacing={0}>
      {planActivo?.plan_productivo_almacenes?.map((alma, index) => (
        <Grid
          item
          xs={6}
          sx={{ p: 2, display: "flex", alignItems: "flex-start" }}
          key={alma.pp_alma_id}
        >
          <Paper sx={{ width: "100%", p: 2 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {alma.almacenes?.alma_nombre || "Almacén sin nombre"}
              </Typography>
              {!!alma.almacenes.alma_secuencial && (
                <>
                  {reorderedItems === alma.pp_alma_id ? (
                    <Button
                      variant="outlined"
                      className="btn_system"
                      sx={{ width: "fit-content", margin: "10px 10px" }}
                      onClick={() => updatePrioridad(reorderedItems)}
                    >
                      Guardar
                    </Button>
                  ) : (
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Button
                        variant="outlined"
                        className="btn_system"
                        sx={{ width: "fit-content", margin: "10px 10px" }}
                        disabled={
                          reorderedItems !== null &&
                          reorderedItems !== alma.pp_alma_id
                        }
                        onClick={() => {
                          handleOpenNuevoItemSec(alma.pp_alma_id);
                        }}
                      >
                        Nuevo item
                      </Button>
                      <Button
                        variant="outlined"
                        className="btn_system"
                        sx={{ width: "fit-content", margin: "10px 10px" }}
                        disabled={
                          reorderedItems !== null &&
                          reorderedItems !== alma.pp_alma_id
                        }
                        onClick={() => {
                          if (alma.almacenes?.alma_secuencial) {
                            setReorderedItems(alma.pp_alma_id);
                          }
                        }}
                      >
                        Editar
                      </Button>
                    </div>
                  )}
                </>
              )}
              {!alma.almacenes.alma_secuencial && (
                <>
                  <Button
                    variant="outlined"
                    className="btn_system"
                    sx={{ width: "fit-content", margin: "10px 10px" }}
                    disabled={reorderedItems !== null}
                    onClick={() => handleOpenEditSec(alma)}
                  >
                    Editar
                  </Button>
                </>
              )}
            </div>

            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {!!alma.almacenes?.alma_secuencial && (
                      <TableCell>Hecho</TableCell>
                    )}
                    <TableCell>
                      {alma.almacenes?.alma_secuencial ? "Prioridad" : "Racks"}
                    </TableCell>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Parte</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {alma?.plan_productivo_almacen_items
                    ?.filter((item) => item.pp_alma_item_done === 0)
                    .map((row, index) => (
                      <TableRow key={index} hover>
                        {!!alma.almacenes?.alma_secuencial && (
                          <TableCell>
                            <Checkbox
                              checked={row.pp_alma_item_done === 1}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  row.pp_alma_item_id,
                                  e.target.checked,
                                )
                              }
                              slotProps={{
                                input: { "aria-label": "controlled" },
                              }}
                              disabled={
                                (alma.plan_productivo_almacen_items?.filter(
                                  (item) => item.pp_alma_item_done === 0,
                                )[index - 1]?.pp_alma_item_done !== 1 &&
                                  index !== 0) ||
                                row.pp_alma_item_done === 1
                              }
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          {reorderedItems === alma.pp_alma_id ? (
                            <select
                              value={row.pp_alma_item_prioridad}
                              onChange={(e) =>
                                handlePriorityChange(
                                  row.pp_alma_item_id,
                                  e.target.value,
                                )
                              }
                            >
                              {alma?.plan_productivo_almacen_items
                                ?.filter((item) => item.pp_alma_item_done === 0)
                                .map((row, index) => (
                                  <option
                                    key={row?.pp_alma_item_prioridad}
                                    value={row?.pp_alma_item_prioridad}
                                  >
                                    {row?.pp_alma_item_prioridad}
                                  </option>
                                ))}
                            </select>
                          ) : (
                            row.pp_alma_item_prioridad || row.pp_alma_item_racks
                          )}
                        </TableCell>
                        <TableCell>
                          {row?.empresas?.emp_razonsocial ||
                            "Cliente no encontrado"}
                        </TableCell>
                        <TableCell>{row?.partes?.part_nombre || ""}</TableCell>
                      </TableRow>
                    ))}

                  {alma?.plan_productivo_almacen_items
                    ?.filter((item) => item.pp_alma_item_done === 1)
                    .map((row, index) => (
                      <TableRow key={index} hover>
                        {!!alma.almacenes?.alma_secuencial && (
                          <TableCell>
                            <Checkbox
                              checked={row.pp_alma_item_done === 1}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  row.pp_alma_item_id,
                                  e.target.checked,
                                )
                              }
                              slotProps={{
                                input: { "aria-label": "controlled" },
                              }}
                              disabled={
                                (alma.plan_productivo_almacen_items[index - 1]
                                  ?.pp_alma_item_done !== 1 &&
                                  index !== 0) ||
                                row.pp_alma_item_done === 1
                              }
                            />
                          </TableCell>
                        )}
                        <TableCell>
                          {reorderedItems === alma.alma_id ? (
                            <select
                              value={row.pp_alma_item_prioridad}
                              onChange={(e) =>
                                handlePriorityChange(
                                  row.pp_alma_item_id,
                                  e.target.value,
                                )
                              }
                            >
                              {alma?.plan_productivo_almacen_items?.map(
                                (_, index) => (
                                  <option key={index + 1} value={index + 1}>
                                    {index + 1}
                                  </option>
                                ),
                              )}
                            </select>
                          ) : (
                            row.pp_alma_item_prioridad || row.pp_alma_item_racks
                          )}
                        </TableCell>
                        <TableCell>
                          {row?.empresas?.emp_razonsocial ||
                            "Cliente no encontrado"}
                        </TableCell>
                        <TableCell>{row?.partes?.part_nombre || ""}</TableCell>
                      </TableRow>
                    ))}

                  {alma?.plan_productivo_almacen_items?.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        sx={{ color: "text.secondary" }}
                      >
                        Sin datos
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
